import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IVariationAsset } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useViewAssetsWithComponents = (
  filters: string[] = [],
  overrideQuerySetting?: UseQueryOptions<IVariationAsset[]>,
) => {
  return useQuery({
    queryKey: queryKeys.viewAssetsWithComponents.all(filters),
    queryFn: () => fetchViewAssetsWithComponents(filters),
    staleTime: Infinity,
    refetchOnWindowFocus: 'always',
    ...overrideQuerySetting,
  });
};

export const fetchViewAssetsWithComponents = async (filters: string[] = []) => {
  const queryString = filters.length > 0 ? `${filters.join('&')}&` : '';
  const response = await requestCCApi({
    url: `/viewAssetsWithComponents?${queryString}pageSize=0`,
  });

  return response.data;
};
